module.exports = function (app) {
    'use strict';
    app.directive('employerProfileSummary', function () {
        return {
            template: require('directives/profile/employerProfileSummary.html'),
            controller: ['$scope', 'sessionData', function($scope,sessionData){
                $scope.viewOnly = sessionData.employerInfo.planAdministrator.displayLoginId.indexOf('VIEW') >= 0;
                if(sessionData.employerInfo){
                    $scope.employer = sessionData.employerInfo.planAdministrator;
                }
              }
            ]
        };
    });
};
